"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouter = require("react-router");

var _UrlPathParams = require("settings-ui-sdk/constants/UrlPathParams");

var _tracking = require("settings-ui-app/utils/tracking");

var _DomainsContainer = _interopRequireDefault(require("./containers/DomainsContainer"));

var _AsyncContainers = require("./AsyncContainers");

var _SitemapsContainer = _interopRequireDefault(require("./containers/SitemapsContainer"));

var _SitemapsRedirectContainer = _interopRequireDefault(require("./containers/SitemapsRedirectContainer"));

var _constants = require("./constants");

var _default = _react.default.createElement(_reactRouter.Route, {
  path: _UrlPathParams.DOMAINS,
  component: _DomainsContainer.default
}, _react.default.createElement(_reactRouter.IndexRedirect, {
  to: _constants.LANGUAGE_SETTINGS_ROUTE
}), _react.default.createElement(_reactRouter.Route, {
  path: _constants.LANGUAGE_SETTINGS_ROUTE,
  component: _AsyncContainers.AsyncBaseLanguageSettingsContainer,
  onEnter: (0, _tracking.trackScreenUsingSideNav)(_constants.LANGUAGE_SETTINGS_ROUTE)
}), _react.default.createElement(_reactRouter.Route, {
  path: _constants.SITEMAPS_ROUTE,
  component: _SitemapsContainer.default,
  onEnter: (0, _tracking.trackScreenUsingSideNav)(_constants.SITEMAPS_ROUTE)
}, _react.default.createElement(_reactRouter.IndexRoute, {
  component: _SitemapsRedirectContainer.default
}), _react.default.createElement(_reactRouter.Route, {
  path: ":id",
  component: _AsyncContainers.AsyncSitemapsSettingsContainer
})));

exports.default = _default;
module.exports = exports.default;